import React from "react"
import type { CSSProperties } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import type { IconProp } from "@fortawesome/fontawesome-svg-core"
import cx from "classnames"

/* TODO: Make svg icon for all other social icons and add them to the svgIcons array */
import { icons, svgIcons } from "./icons"
import "./library"

export const lookupSocialIcon = (icon: string) =>
  icons.find(i => i.iconName === icon)

const FontAwesomeNameFallbacks = [
  { old: "external-link", new: "arrow-up-right-from-square" },
  { old: "shopping-cart", new: "cart-shopping" },
  { old: "telegram-plane", new: "telegram" },
  { old: "snapchat-ghost", new: "snapchat" }
]

const SIZES: Record<string, string> = {
  sm: "size-4",
  md: "size-6",
  lg: "size-8"
}

export type SocialIconProps = {
  name?: string
  size?: "sm" | "md" | "lg"
  style?: CSSProperties
  className?: string
}

export default function SocialIcon({
  name,
  size,
  style,
  className
}: SocialIconProps) {
  const sizeClass = size ? SIZES[size] : null
  const svgIcon = svgIcons.find(i => i.name === name)
  if (svgIcon) {
    const IconComponent = svgIcon.component
    return (
      <IconComponent
        className={cx(className, "inline-block", sizeClass || "w-3")}
        style={{ fontSize: "inherit", ...style }}
      />
    )
  }
  let iconName
  if (name && typeof name == "string") {
    const oldName = FontAwesomeNameFallbacks.find(f => f.old === name)
    if (oldName) {
      iconName = lookupSocialIcon(oldName.new)
    } else {
      iconName = lookupSocialIcon(name)
    }
  }

  return (
    <FontAwesomeIcon
      icon={iconName as IconProp}
      className={cx({ "inline-block": size }, sizeClass, className)}
      style={style}
    />
  )
}
